import { createBlobUrlCache } from '@linc-technologies/linced-common/utils/blob-url-lru-cache';
import type MediaService from '@linc-technologies/linced-common/services/media';

// LRU blob URL cache keyed by `${mediaId}|${rendition}`. Used by
// components/media-image.js.
export const mediaImageBlobUrlCache = createBlobUrlCache();

// resolveMediaImageUrl resolves the blob URL for a content image referenced
// only by a bare mediaId (badges, category badges -- not person/group
// avatars, see utils/avatar-url.js for that; and not a full Media record,
// see utils/media-url.js for that). Returns null when there's no mediaId or
// the fetch fails -- callers render nothing in that case, there is no
// gravatar/default-image fallback here.
export async function resolveMediaImageUrl(
  media: MediaService,
  mediaId: string | null | undefined,
  original?: boolean,
): Promise<string | null | undefined> {
  if (!mediaId) return null;

  const rendition = original ? null : 'avatar';
  const cacheKey = `${mediaId}|${rendition ?? 'original'}`;

  const cached = mediaImageBlobUrlCache.get(cacheKey);
  if (cached) return cached;

  const url = await media.getImageBlobUri(mediaId, '', rendition);
  if (url) mediaImageBlobUrlCache.set(cacheKey, url);
  return url;
}
